import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { Component, DestroyRef, EventEmitter, OnDestroy, OnInit, Output, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslocoPipe } from '@jsverse/transloco';
import { LoadingIndicatorDirective } from '@zero/shared/ui-directives';
import { TradingSessionComponent } from '@zero/shared/ui-web-components';
import { ButtonComponent } from '@zero/shared/ui-web-design-system';
import { TradeFacade } from '@zero/trade/domain';
import { filter } from 'rxjs';
import { MultiOrderConfirmOrdersComponent } from '../multi-order-confirm-orders/multi-order-confirm-orders.component';
import { MultiOrderErrorComponent } from '../multi-order-error/multi-order-error.component';
import { MultiOrderEstimatedSumComponent } from '../multi-order-estimated-sum/multi-order-estimated-sum.component';
import { MultiOrderSummaryComponent } from '../multi-order-summary/multi-order-summary.component';

@Component({
  selector: 'trade-multi-order-confirm',
  imports: [
    LoadingIndicatorDirective,
    MultiOrderConfirmOrdersComponent,
    AsyncPipe,
    TranslocoPipe,
    MultiOrderSummaryComponent,
    TradingSessionComponent,
    MultiOrderErrorComponent,
    MultiOrderEstimatedSumComponent,
    ButtonComponent,
    UpperCasePipe,
  ],
  templateUrl: './multi-order-confirm.component.html',
  styleUrl: './multi-order-confirm.component.scss',
})
export class MultiOrderConfirmComponent implements OnInit, OnDestroy {
  @Output() public goBack = new EventEmitter<void>();
  @Output() public goNext = new EventEmitter<void>();

  public readonly facade = inject(TradeFacade);
  readonly #destroyRef = inject(DestroyRef);

  public hasTradingSession = false;

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.facade.loadExante();
    this.facade.sendSuccess$
      .pipe(
        filter((isSuccessfullySent) => !!isSuccessfullySent),
        takeUntilDestroyed(this.#destroyRef),
      )
      .subscribe(() => this.goNext.emit());
  }

  ngOnDestroy(): void {
    this.facade.resetMultiOrderVerification();
  }

  public setTradingSessionState(hasTradingSession: boolean) {
    this.hasTradingSession = hasTradingSession;
  }
}
